import { Assessment as ReportIcon, BuildRounded, History as AuditIcon, Notifications as NotificationsIcon, Category as CategoryIcon } from '@mui/icons-material';
import type { NavItemType } from '../types/menu';

const icons = {
  system: BuildRounded,
  reports: ReportIcon,
  category: CategoryIcon,
  audit: AuditIcon,
  notifications: NotificationsIcon,
};

const setting: NavItemType = {
  id: 'group-system',
  title: 'Setting',
  type: 'group',
  icon: icons.system,
  children: [
    {
      id: 'profile',
      title: 'Profile',
      color: 'primary',
      type: 'item',
      url: '/profile',
      icon: icons.reports,
      navAlwaysAccessible: true,
    },
  ],
  color: undefined,
  url: undefined
};

export default setting;
